import { PlusIcon } from "lucide-react";
import { NsKey } from "enums/NsKey";
import { useDynamicTranslation } from "hooks/useDynamicTranslation";
import { FC } from "react";

interface AddLoanButtonProps {
  onClick: () => void;
}

export const AddLoanButton: FC<AddLoanButtonProps> = ({ onClick }) => {
  const { t } = useDynamicTranslation([NsKey.Borrower]);

  return (
    <div className="flex w-full items-center justify-center">
      <button
        onClick={onClick}
        className="group flex items-center gap-2.5 px-4 py-2 transition-colors hover:opacity-70 focus:outline-none"
      >
        <div className="flex items-center justify-center w-7 h-7 rounded-full border-2 border-dashed border-primary text-primary transition-colors">
          <PlusIcon className="w-4 h-4" />
        </div>
        <span className="text-sm font-medium text-primary transition-colors whitespace-nowrap">
          {t("BORROWER.LABELS.ADD_LOAN")}
        </span>
      </button>
    </div>
  );
};
